import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 20c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8zm0 2C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10-4.5 10-10 10zm0-14a1 1 0 100-2 1 1 0 000 2zm-2.4 3.9L9 10l2.7-.9c.7-.2 1.4.4 1.3 1.1l-.8 5.3 1.5-.5.6 1.9-3 1c-.7.2-1.4-.4-1.3-1.1l.8-5.4-1.2.5z"
    />
  </svg>
);
